import {isMobile} from "react-device-detect";
import MobileMyServices from "./MobileMyServices";
import DesktopMyServices from "./DesktopMyServices";

export default isMobile ? MobileMyServices : DesktopMyServices;